import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactSection = () => {
  return (
    <section id="contact" data-testid="contact-section" className="py-20 bg-white">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-semibold text-[var(--vp-ink)] mb-4">
            Kontakt
          </h2>
          <p className="text-[var(--vp-ink)]/70 max-w-2xl mx-auto">
            Máte otázky? Napište nám a ozveme se vám co nejdříve.
          </p>
        </motion.div>

        <div className="max-w-2xl mx-auto">
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="flex flex-col justify-center"
          >
            <div className="bg-[var(--vp-sand)] rounded-3xl p-8 mb-6">
              <h3 className="text-lg font-semibold text-[var(--vp-ink)] mb-4">
                Odpovíme do 24 hodin
              </h3>
              <p className="text-[var(--vp-ink)]/70 mb-6">
                Většinou to zvládneme mnohem rychleji. Přes víkend může odpověď trvat trochu déle.
              </p>

              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center">
                    <Mail className="w-5 h-5 text-[var(--vp-pink)]" />
                  </div>
                  <div>
                    <p className="text-sm text-[var(--vp-ink)]/60">E-mail</p>
                    <a
                      href="mailto:info@vyzvaprijata.eu"
                      className="font-medium text-[var(--vp-ink)] hover:text-[var(--vp-pink)] transition-colors"
                    >
                      info@vyzvaprijata.eu
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center">
                    <Phone className="w-5 h-5 text-[var(--vp-pink)]" />
                  </div>
                  <div>
                    <p className="text-sm text-[var(--vp-ink)]/60">Telefon</p>
                    <a
                      href="tel:+420721665622"
                      className="font-medium text-[var(--vp-ink)] hover:text-[var(--vp-pink)] transition-colors"
                    >
                      +420 721 665 622
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-[var(--vp-pink)]" />
                  </div>
                  <div>
                    <p className="text-sm text-[var(--vp-ink)]/60">Adresa</p>
                    <p className="font-medium text-[var(--vp-ink)]">
                      Fráni Šrámka 2457/28, Ostrava
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;